module.exports = new __parcel__URL__("crossIconRed.7ccbf462.svg").toString();